import { ReactElement } from "react";
import styled from "styled-components";
import { Image } from "components/Image";
import { MEDIA } from "ui/components/shared/constants";

type Props = {
    slug: string;
    header: string;
    image: string;
    employeeBadge: string;
    dynamicUrlContentLink?: string;
};

const StyledCard = styled.a`
    background: #bde2e5;
    border-radius: 2.5rem 0;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    height: 20rem;
    justify-content: space-between;
    padding: 1.5rem;
    scroll-snap-align: start;
    width: 18.75rem;

    @media (${MEDIA.lg}) {
        height: 26rem;
        width: 26.8125rem;
    }

    :focus {
        outline: none;
    }

    :hover {
        text-decoration: none;
    }
`;

const ImageContainer = styled.div`
    display: flex;
    align-items: center;
    height: 100%;
    justify-content: center;
`;

const StyledImage = styled(Image)`
    background: transparent;
`;

const Title = styled.span`
    color: ${({ theme }) => theme.colors.secondary[900]};
    font-family: ${({ theme }) => theme.typography.fontFamily.primary};
    font-size: 1.5rem;
    font-weight: 500;
    line-height: 2rem;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
`;

const TitleWrapper = styled.div`
    min-height: 3.5rem;
`;

const StyledEmployeeImage = styled(Image)`
    width: 7rem;
    background-color: transparent;
`;

export const Card = ({
    slug,
    header,
    image,
    employeeBadge,
    dynamicUrlContentLink
}: Props): ReactElement => {
    return (
        <StyledCard data-testid="tips-card" href={dynamicUrlContentLink ?? `/blog/tips/${slug}`}>
            <StyledEmployeeImage src={employeeBadge} alt="employee-badge" />
            <ImageContainer>
                <StyledImage src={image} alt={slug} />
            </ImageContainer>
            <TitleWrapper>
                <Title>{header}</Title>
            </TitleWrapper>
        </StyledCard>
    );
};
